import { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import useSWR from "swr";
import { ApiKey } from "../../common/request/apiKey";
import { useApiTrigger } from "../../common/request/useApiTrigger";
import { usePostRequest } from "../../common/request/usePostRequest";
import { GetUserDddInfoRequest, GetUserDddInfoResponse } from "./types";

export const useGetUserDDDInfoTrigger = () => {
  return useApiTrigger<GetUserDddInfoResponse, GetUserDddInfoRequest>({
    method: ApiKey.GET_USER_DDD_INFO,
  });
};

export const useGetUserDDDInfoFetch = (
  params: GetUserDddInfoRequest,
  shouldFetch = true
) => {
  const { createPostRequest } = usePostRequest();
  const fetcher = useCallback(
    async (key: [ApiKey, number]) => {
      const [method, cardId] = key;
      return await createPostRequest(method, {
        params: {
          cart_id: cardId,
        },
      });
    },
    [createPostRequest]
  );

  const { data, error, mutate, isLoading, isValidating } = useSWR<
    AxiosResponse<{ result: GetUserDddInfoResponse }>["data"],
    AxiosError<{ error: unknown }>
  >(shouldFetch ? [ApiKey.GET_USER_DDD_INFO, params.cart_id] : null, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return { data: data?.result, error, mutate, isLoading, isValidating };
};
